export function getUTMParams() {
  const params = new URLSearchParams(window.location.search);
  // console.log({
  //   utm_source: params.get("utm_source") || "",
  //   utm_campaign: params.get("utm_campaign") || "",
  //   utm_medium: params.get("utm_medium") || "",
  // });
  return {
    utm_source: params.get("utm_source") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_medium: params.get("utm_medium") || "",
  };
}
